$(document).ready(function() {
  const initSlider = ($wrap, settings) => {
    $wrap.slick(settings);
  };

  const initMobileSlider = ($wrap, settings, width) => {
    if ($(window).width() <= width) {
      if (!$wrap.hasClass("slick-initialized")) {
        initSlider($wrap, settings);
      }
    } else {
      if ($wrap.hasClass("slick-initialized")) {
        setTimeout(function () {
          $wrap.slick("unslick");
        }, 100);
      }
    }
  };

  const aboutGallerySettings = {
    dots: true,
    arrows: false,
    prevArrow:
      '<button type="button" class="slick-prev button button--green"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button button--green"><i class="vi-trigon-icon"></i></button>',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  initMobileSlider($(".js-about-gallery-slider"), aboutGallerySettings, 990);

  $(window).on("resize", function () {
    initMobileSlider($(".js-about-gallery-slider"), aboutGallerySettings, 990);
  });

  $(".js-article-slider").slick({
    dots: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev button button--green"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button button--green"><i class="vi-trigon-icon"></i></button>',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  $(".js-recent-projects-slider").slick({
    dots: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev button button--green"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button button--green"><i class="vi-trigon-icon"></i></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  $(".js-brands-slider").slick({
    dots: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  $(".js-banners-slider").slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $(".js-banners-mob-slider").slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $(".js-compare-slider").slick({
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
  });

  $(".js-compare-video-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: true,
        },
      },
    ],
  });

  $(".js-slider-additional-services").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  $(".js-dealers-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  $(".js-events-slider").each((index, slider) => {
    $(slider).slick({
      dots: true,
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow:
        '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            dots: true,
            arrows: false,
          },
        },
      ],
    });
  });

  $(".js-part-table-slider").slick({
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
  });

  $(".js-part-catalog-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  });

  $(".js-event-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  });

  $(".js-partners-banks-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  $(".js-about-team-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".js-about-partner-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".js-about-enterprise-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".js-crop-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="slick-prev button"><i class="vi-trigon-icon"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next button"><i class="vi-trigon-icon"></i></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  });

  $(".js-banners-next").on("click", function () {
    const slider = $(".js-banners-slider").get(0).slick;
    if (slider.slideCount - 1 === slider.currentSlide) {
      slider.goTo(0);
    } else {
      slider.slickNext();
    }
  });

  $(".js-banners-prev").on("click", function () {
    const slider = $(".js-banners-slider").get(0).slick;
    if (!slider.currentSlide) {
      slider.goTo(slider.slideCount);
    } else {
      slider.slickPrev();
    }
  });

  setTimeout(function() {
    if ($(window).width() <= 990) {
      $('.js-about-gallery-slider').slick('refresh');
    }
    $('.js-brands-slider').slick('refresh');
  }, 500);
});
